<template>
    <div class="flex flex-col min-h-[calc(100vh-32px)] bg-white" data-cy="container_financial_health_quiz_question">
        <!-- Progress Bar -->
        <QuizProgressBar :currentCategory="currentCategory" />
        
        <!-- Content -->
        <div class="flex-1 px-4 pb-4 overflow-y-auto">
            <!-- Category Icon -->
            <div class="mb-4">
                <img 
                    :src="categoryIcon" 
                    :alt="categoryTitle"
                    class="w-8 h-8 object-contain"
                />
            </div>
            
            <!-- Category Title -->
            <h1 class="text-24 font-bold text-a-black mb-2">
                {{ categoryTitle }}
            </h1>
            
            <!-- Question Title -->
            <h2 class="text-16 font-medium text-a-black mb-1">
                {{ questionTitle }}
            </h2>
            
            <!-- Question Subtitle -->
            <div class="text-16 text-a-black leading-relaxed"
               :class="notice ? 'mb-4' : 'mb-6'">
                <div v-html="questionSubtitle"></div>
            </div>
            <!-- Notice 1 -->
            <p v-if="notice1" class="text-16 text-a-black font-medium mb-6">
                {{ notice1 }}
            </p>
            <!-- Notice -->
            <p v-if="notice" class="text-16 text-a-black font-medium mb-4 ">
                {{ notice }}
            </p>

            
            <!-- Choices -->
            <div class="space-y-3">
                <QuizChoice
                    v-for="choice in choices"
                    :key="choice.value"
                    :value="choice.value"
                    :label="choice.label"
                    :selectedValue="selectedAnswer"
                    :fontClass="choiceFont"
                    @select="handleSelect"
                />
            </div>
        </div>
        
        <!-- Bottom Buttons -->
        <div class="sticky bottom-0 bg-white px-4 py-4  ">
            <div class="flex gap-3">
                <SecondaryButton 
                    data-cy="btn_financial_health_quiz_back"
                    text="ย้อนกลับ"
                    class="flex-1"
                    @click="$emit('back')"
                />
                <PrimaryButton 
                    data-cy="btn_financial_health_quiz_next"
                    text="ต่อไป"
                    class="flex-1"
                    :disabled="!selectedAnswer"
                    @click="handleNext"
                />
            </div>
        </div>
    </div>
</template>

<script>
import QuizProgressBar from './QuizProgressBar.vue';
import QuizChoice from './QuizChoice.vue';
import PrimaryButton from '@/components/Button/PrimaryButton.vue';
import SecondaryButton from '@/components/Button/SecondaryButton.vue';

export default {
    name: "QuizQuestion",
    emits: ['next', 'back', 'answer'],
    components: {
        QuizProgressBar,
        QuizChoice,
        PrimaryButton,
        SecondaryButton
    },
    props: {
        // Current category index (0-3)
        currentCategory: {
            type: Number,
            required: true
        },
        // Category icon
        categoryIcon: {
            type: String,
            required: true
        },
        // Category title (e.g., "พฤติกรรมการใช้จ่าย")
        categoryTitle: {
            type: String,
            required: true
        },
        // Question title
        questionTitle: {
            type: String,
            required: true
        },
        // Question subtitle/description
        questionSubtitle: {
            type: String,
            default: ''
        },
        // Notice text (optional)
        notice: {
            type: String,
            default: ''
        },
        // Notice text (optional)
        notice1: {
            type: String,
            default: ''
        },
        // Array of choices: [{ value, label }]
        choices: {
            type: Array,
            required: true
        },
        // Font class for choices (optional)
        choiceFont: {
            type: String,
            default: ''
        },
        // Pre-selected answer value
        initialAnswer: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            selectedAnswer: this.initialAnswer
        };
    },
    watch: {
        initialAnswer: {
            immediate: true,
            handler(newVal) {
                this.selectedAnswer = newVal;
            }
        },
        // Reset selection when question changes
        questionTitle() {
            this.selectedAnswer = this.initialAnswer;
        }
    },
    methods: {
        handleSelect(value) {
            this.selectedAnswer = value;
            this.$emit('answer', value);
        },
        handleNext() {
            if (this.selectedAnswer) {
                this.$emit('next', this.selectedAnswer);
            }
        }
    }
};
</script>
